import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDuration(hours: number | undefined) {
  if (!hours) return '-';
  if (hours >= 24) {
    // Only show pure days if exact multiple of 24, otherwise mixing days/hours might be complex
    // The requirement was simple: > 24 hours -> show days.
    // Let's stick to simple logic: if > 24, show as X Days.
    // Wait, let's look at example: "48 Hours" -> "2 Days". "72 Hours" -> "3 Days".
    // What if 25 hours? "1.04 Days" or keep "25 Hours"?
    // "showing days when more than 24 hours"
    // Let's assume standard increments (24, 48, 72).
    // If it's 25, maybe "1 Day 1 Hour"?
    // The prompt examples show exact days.
    // Let's implement decimal days for non-exact if needed, or just standard days.
    
    const daysVal = hours / 24;
    // Check if integer
    if (Number.isInteger(daysVal)) {
         return `${daysVal} Days`;
    }
    // If not integer, maybe keep hours or show decimal days?
    // Let's stick to a safe approach:
    // If > 24, divide by 24.
    
    return `${parseFloat(daysVal.toFixed(1))} Days`;
  }
  return `${hours} Hours`;
}
export function formatCurrency(amount: number | string) {
  const val = typeof amount === 'string' ? parseFloat(amount) : amount;
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true,
  }).format(isNaN(val) ? 0 : val);
}

export function parseCurrency(value: string): number {
  return parseFloat(value.replace(/\D/g, "")) || 0;
}

/**
 * Returns a human readable relative time string (e.g. "2h ago", "15m ago")
 */
export function formatTimeAgo(dateInput: string | Date | undefined) {
  if (!dateInput) return "";
  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) return "Just now";
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
  return `${Math.floor(diffInSeconds / 86400)}d ago`;
}
